// extracted by mini-css-extract-plugin
export default {"add_meal_container":"AddMeal_add_meal_container__wpwWw"};